export const CAMPAIGN_STATUSES = {
    DRAFT: 'draft',
    NOT_STARTED: 'non_started',
    ACTIVE: 'active',
    PAUSED: 'paused',
    FINISHED: 'finished',
};

export const CAMPAIGN_ACTIVATED_STATUSES = [
    CAMPAIGN_STATUSES.ACTIVE,
    CAMPAIGN_STATUSES.PAUSED,
    CAMPAIGN_STATUSES.FINISHED,
];
